import { createSelector } from 'reselect'
import pendingRequestsSelector from './pendingRequestsSelector'
import requestIsPending from './helpers/requestIsPending'
import { API_URL_COMPARISON_CARLINE_STRUCTURE } from '../../../constants/apiUrls'

const comparisonCarlineStructureRequestIsPendingSelector = createSelector(
    pendingRequestsSelector,
    (pendingRequests): boolean => requestIsPending(pendingRequests, API_URL_COMPARISON_CARLINE_STRUCTURE),
)

export default comparisonCarlineStructureRequestIsPendingSelector
